import { render, staticRenderFns } from "./recycleDialog.vue?vue&type=template&id=85c0c4aa"
import script from "./recycleDialog.vue?vue&type=script&lang=js"
export * from "./recycleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports